export default function MessageBubble({ message }) {
  const isSent = message.direction === "outgoing";
  const isBot = message.from_bot;
  const timeStr = message.created_at
    ? new Date(message.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
    : "";

  return (
    <div className={`flex ${isSent ? "justify-end" : "justify-start"} mb-2`}>
      <div
        className={`max-w-[75%] rounded-xl px-3 py-2 ${
          isSent
            ? isBot
              ? "bg-indigo-100 text-indigo-900"
              : "bg-emerald-100 text-emerald-900"
            : "bg-white border text-gray-800"
        }`}
      >
        {isBot && <p className="text-[10px] text-indigo-400 font-medium mb-0.5">IA</p>}
        <p className="text-sm whitespace-pre-wrap">{message.text}</p>
        <p className="text-[10px] text-gray-400 text-right mt-0.5">{timeStr}</p>
      </div>
    </div>
  );
}
